<div
  class="icon-container"
  [ngClass]="{
    'hover-style': isWithHover,
  }"
  [innerHTML]="getIcon()"
></div>
